import { useAuthStore } from "../../stores";

export interface Station {
  id: string;
  name: string;
  ready: boolean;
  last_seen_at: string | null;
  preview: string | null;
  settings: Record<string, unknown>;
}
export interface Recording {
  id: string;
  station_id: string;
  wi_sf_id: string;
  wi_name: string;
  status: string;
  created_at: string;
  started_at: string | null;
  interrupted: boolean;
  duration_seconds: number | null;
  detail: string | null;
  media_id?: string | null;
}
export interface CameraReply {
  station?: Station;
  token?: string;
  stations?: Station[];
  active?: Recording[];
  recording?: Recording | null;
  recordings?: Recording[];
  uploadUrl?: string;
  saved?: boolean;
  url?: string;
}
export class CameraApiError extends Error {
  constructor(message: string, public status: number) { super(message); }
}
export async function cameraCall(
  action: string,
  data: Record<string, unknown> = {},
  token?: string,
): Promise<CameraReply> {
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
  };
  if (token) headers["X-Camera-Token"] = token;
  else {
    const { staff, pin } = useAuthStore.getState();
    if (!staff?.id || !pin) throw new Error("Log in op de field-app");
    headers["X-Staff-Id"] = staff.id;
    headers["X-Staff-Pin"] = pin;
    useAuthStore.getState().raakSessieAan();
  }
  const abort = new AbortController();
  const timer = setTimeout(() => abort.abort(), 12000);
  try {
    const res = await fetch("/api/camera", {
      method: "POST",
      headers,
      body: JSON.stringify({ action, ...data }),
      signal: abort.signal,
    });
    const reply = await res.json();
    if (!res.ok)
      throw new CameraApiError(reply.error || "Camera-opdracht niet bevestigd", res.status);
    return reply;
  } finally {
    clearTimeout(timer);
  }
}
export function stationFresh(s: Station, now = Date.now()) {
  return !!s.last_seen_at && now - Date.parse(s.last_seen_at) < 12000;
}
export const statusText: Record<string, string> = {
  queued: "Start aangevraagd, nog niet bevestigd",
  recording: "Opname loopt",
  stop_requested: "Stop aangevraagd, nog niet bevestigd",
  uploading: "Opname gestopt, upload nog niet bevestigd",
  saved: "Opgeslagen bij dit kleed",
  promoted: "Opgeslagen en beschikbaar voor social",
  cancelled: "Geannuleerd",
};
